module.exports = __webpack_public_path__ + "static/media/male.6240a5f0.svg";